import React, { useState, useRef } from 'react';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Card } from 'primereact/card';
import { Growl } from 'primereact/growl';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';

import servicioObjetos from '../../servicio/ServicioObjetos';
import ServicioArchivos from "../../servicio/ServicioArchivos";

export const ReportesDif = () => {

    const [fechaMes, setFechaMes] = useState({});
    let growl = useRef(null);

    const handleChange = (e, mayusculas) => {
        const { name, value } = e.target;
        let elValor = value;
        if (mayusculas) {
            if (elValor && typeof elValor !== 'object')
                elValor = elValor.toUpperCase();
        }
        setFechaMes(valoresPrevios => ({
            ...valoresPrevios,
            [name]: elValor
        }));
    };

    const descargaReporte = () => {
        try {

            if (servicioObjetos.esObjetoVacio(fechaMes))
                throw new Error("Selecciona el Mes");
            let fechaPago = new Date(fechaMes.mes).getTime();
            ServicioArchivos.descargaArchivo('documento/descarga_archivo_excel.json', { fechaPago: fechaPago }, this);
        } catch (error) {
            growl.current.show({
                severity: 'error', summary: "Error requeridos",
                detail: error.message, life: 8000
            });
        }

    }

    return (
        <>
            <Growl ref={growl} />
            <Card className="p-col-12 p-md-12">
                <h1 style={{ textAlign: 'center', fontSize: '30px', fontWeight: 'bolder' }} >Reportes DIF</h1>
            </Card>

            <Accordion>
                <AccordionTab header="Descarga Reporte por Mes en Excel">
                    <div className="p-fluid p-formgrid p-grid">
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="firstname6">Selecciona el mes</label>
                            <Calendar name="mes" value={fechaMes.mes} onChange={(e) => handleChange(e, false)} view="month" dateFormat="mm/yy" yearNavigator={true} yearRange="2020:2030" />
                        </div>
                        <div className="p-field p-col-12 p-md-6">
                            <label htmlFor="lastname6">&nbsp;</label>
                            <Button label="Descargar Reporte" className="p-button-raised p-button-info" onClick={descargaReporte} />
                        </div>

                    </div>
                </AccordionTab>
            </Accordion>
        </>);
}